import { tv } from '~/utils/tv'

export const onClearVariants = tv({
  base: 'absolute z-60',
  variants: {
    size: {
      md: 'top-[6px] right-[43px]',
      ml: 'top-[8px] right-[48px]',
      lg: 'top-[12px] right-[48px]',
      xl: 'top-[16px] right-[48px]',
    },
    label: {
      md: 'mt-[20px]',
      ml: 'mt-[23px]',
      lg: 'mt-[23px]',
      xl: 'mt-[22px]',
      false: '',
    },
    disabled: {
      true: 'cursor-not-allowed',
    },
    readonly: {
      true: 'cursor-not-allowed',
    },
  },
  defaultVariants: {
    size: 'md',
    label: false,
  },
})
